/**
 * Polyfill for parents method
 * @param {*} selector
 */
export default function parents(selector) {
  const elements = [];
  let elem = this;
  const isHaveSelector = selector !== undefined;

    while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== window.Node.ELEMENT_NODE) {
      continue; //eslint-disable-line
    }

    if (!isHaveSelector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}


/**
* helper method to get siblings
* @param {*} selector
*/

export const getSiblings = (e) => {
  const siblings = [];

  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }

  // first child of the parent node
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};
